<template>
  <div class="boards-for-user user-collection-page">
    <PHeader></PHeader>
    <UserProfileCard :in-board="true" :username="filters.boardUsername"></UserProfileCard>
    <div class="board-collection-container">
      <div class="user-collection-heading">
        <span class="user-collection-count" aria-live="polite">
          <span class="user-collection-count__label">{{ $t('boardsLink') }}</span>
          <strong>{{ boardsCount }}</strong>
        </span>
      </div>
      <div class="board-collection-surface">
        <Boards :filters="filters" @boards-meta-loaded="onBoardsMetaLoaded"></Boards>
      </div>
    </div>
  </div>
</template>

<script>
import PHeader from '../components/PHeader.vue';
import UserProfileCard from '../components/UserProfileCard.vue';
import Boards from '../components/Boards.vue';

export default {
  name: 'Boards4User',
  data() {
    return {
      filters: { boardUsername: null },
      boardsCount: 0,
    };
  },
  components: {
    PHeader,
    UserProfileCard,
    Boards,
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.boardsCount = 0;
    this.filters = { boardUsername: to.params.username };
    next();
  },
  methods: {
    initialize() {
      this.filters = { boardUsername: this.$route.params.username };
    },
    onBoardsMetaLoaded(meta) {
      this.boardsCount = meta && Number.isFinite(meta.count) ? meta.count : 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.boards-for-user {
  min-height: 100vh;
  background: transparent;
}

/* R6 profile collection alignment */
.user-collection-page {
  --user-profile-content-width: var(--user-profile-shell-width);
}
.user-collection-page .container,
.user-collection-page .section > .container {
  width: 100%;
  max-width: var(--user-profile-content-width);
  margin-right: auto;
  margin-left: auto;
}
.board-collection-container {
  box-sizing: border-box;
  width: var(--user-profile-content-width);
  max-width: 100%;
  margin: 1rem auto 0;
  padding: 0;
}

.board-collection-surface {
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  box-shadow: none;
}

.user-collection-page ::v-deep .board-collection-surface .boards > .section {
  padding: 0;
}

.user-collection-page ::v-deep .board-collection-surface #boards-container {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}

.user-collection-page ::v-deep #pins-container,
.user-collection-page ::v-deep #boards-container,
.user-collection-page ::v-deep .comics-section,
.user-collection-page ::v-deep .comics-grid {
  width: 100%;
  max-width: 100%;
  margin-right: 0;
  margin-left: 0;
}
.user-collection-page ::v-deep .pin-masonry,
.user-collection-page ::v-deep .board-masonry,
.user-collection-page ::v-deep .comic-card-shell {
  min-width: 0;
}
@media screen and (max-width: 540px) {
  .board-collection-container {
    margin-top: 0.8rem;
  }

  .board-collection-surface {
    padding: 0.8rem;
  }
}
</style>
